import React from "react";

import Sidebar from "../components/Sidebar";
import Footer from "../components/default/Footer";
import Content from "../components/default/Content";
import ContentContainer from "../components/default/ContentContainer";
import SidebarContainer from "../components/default/SidebarContainer";

import "../style/HomeView.css";
import Sidemenu from "../components/Sidemenu";

import FacebookSmall from "../components/FacebookSmall";

import Responsive from "react-responsive";
import { isMobile } from "react-device-detect";
import HttpService from "../services/HttpService";
import { Card } from "react-md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";


import { Keyframes, Spring, animated, Easing } from "react-spring/renderprops";

import Header from "../components/default/Header";
import HeaderRight from "../components/default/HeaderRight";

import titleLogo from "../res/img/logo.svg";


library.add(fab);



const config = require("../config/Config");

export class KontaktView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onClickMenuItem = this.onClickMenuItem.bind(this);
    this.openMenu = this.openMenu.bind(this);
  }

  componentDidMount(props) {
    setInterval(() => {
      HttpService.getDeliveryTime().then(data => {
        this.props.updateDeliveryTime(data.time);
      });

      HttpService.getTakeawayTime().then(data => {
        this.props.updateTakeawayTime(data.time);
      });
    }, 15000);
  }

  openMenu() {
    this.setState(
      Object.assign({}, this.state, {
        // menuShown: !this.state.menuShown,
        showSidbarLeft: !this.state.showSidbarLeft,
        sidebarIsOpen: false,
      })
    );
  }

  // openSidebar() {
  //   this.setState(
  //     Object.assign({}, this.state, {
  //       sidebarIsOpen: !this.state.sidebarIsOpen,
  //       showSidbarLeft: false,
  //     })
  //   );
  // }

  onClickMenuItem(level, item) {
    this.props.history.push({
      pathname: item.path,
      state: { clicked: item.name }
    }); //this.props.location.pathname === path ? "": name}})

    if (item.name !== undefined) {
      this.setState(
        Object.assign({}, this.state, { selectedCat: item.selection })
      );
    }
  }

  render() {
    return (
      <div
        className={"flexBoxColumn"}
        style={{ height: "100vh", justifyContent: "space-between" }}
      >
        <Header
          title={config.info.title}
          subTitle={config.info.subTitle}
          titleMobile="Roma"
          subTitleMobile=""
          titleLogo={titleLogo}
          openMenu={this.openMenu}
          socialMedia={false}
          openSidebar={this.openSidebar}
          cart={this.props.cart}
        >
        </Header>

        <div
          style={{
            width: "100%",
            position: isMobile ? "" : "absolute",
            top: 75,
            zIndex: isMobile ? "" : 1010,
            position: "absolute",
          }}
        >
          <div
            style={{
              opacity: isMobile ? (this.state.showSearch ? "0.7" : "1") : "1",
              transition: " 2s",
              paddingLeft: 20,
              position: "absolute",
              right: isMobile ? undefined : 0,
              zIndex: 1011,
              display: isMobile ? "flex" : undefined,
              flexDirection: isMobile ? "row" : undefined,
            }}
          >
            <FacebookSmall />
          </div>
        </div>

        <ContentContainer scrollable={true} mode={"footer"}>
        <SidebarContainer
            direction={"left"}
            sidebarIsOpen={this.state.showSidbarLeft}
            showMenu={this.openMenu}
            width={"20%"}
            fixed={true}
            from={"left"}
            background={true}
          >
            <Sidemenu
              // allowedCategories={this.state.filter.allowedCategories}
              menu={config.menu}
              selected={"Kontakt"}
              onClickMenuItem={this.onClickMenuItem}
              setMenuWidth={this.setMenuWidth}
              overlap={true}
              showMenu={this.openMenu}
              style={{ marginTop: isMobile ? 10 : 100 }}
              clicked={this.props.history.location.state !== undefined ? this.props.history.location.state.clicked : undefined}
            />
          </SidebarContainer>

          <Content width="40%" style={{ marginTop: isMobile ? "0px" : 100 }}>
            <Card style={{ padding: 10 }}>
              <p>
                Sie finden uns unter der folgendenen Adresse im schönen
                Marl-Polsum.
              </p>
              <div
                style={{
                  margin: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <p>{config.info.title}</p>
                <p>{config.info.subTitle.address}</p>
                <a href={config.info.subTitle.telAttr}>
                  {config.info.subTitle.tel}
                </a>
              </div>
              <p>
                Lassen Sie uns gerne einen "Daumen-Hoch" da oder folgen Sie uns
                auf unseren Social Media Kanälen.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  marginBottom: 20
                }}
              >
                {config.info.social.map(x => (
                  <FontAwesomeIcon
                    icon={["fab", `${x.name}`]}
                    color="#3C5A99"
                    size="3x"
                    onClick={() => window.open(x.url, "_blank")}
                  />
                ))}
              </div>
              <p>
                Wenn Sie Anregungen oder Feedback haben, dann können Sie gerne
                Kontakt über unser Feedback-Formular aufnehmen.
              </p>
            </Card>
          </Content>

          <SidebarContainer
            direction={"right"}
            width={"30%"}
            // fixed={true}
            showSidebar={false} //{this.state.showSidebar}
            from={"top"}
          >
            {/* <Sidebar
              isOpen={this.props.isOpen}
              cart={this.props.cart}
              offer={this.props.offer}
              offerCart={this.props.offerCart}
              updateCart={this.props.updateCart}
              showSidebar={this.state.showSidebar}
              openSidebar={this.openSidebar}
              removeOffer={this.removeOffer}
              style={{ marginTop: isMobile ? 0 : 100 }}
              addOfferToCart={this.addOfferToCart}
              deliveryTime={this.props.deliveryTime}
              takeawayTime={this.props.takeawayTime}
            /> */}
          </SidebarContainer>
          <Footer />
        </ContentContainer>
      </div>
    );
  }
}

const styles = {
  footerStart: {
    minHeight: "120px"
  },
  background: {},
  contentCard: {}
};
